import React from "react";

class PdfICon extends React.Component {
  render() {
    return (
      <div>
        <svg
          width={this.props.width || "16px"}
          height={this.props.height || "16px"}
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
        >
          <title>9697147C-F6B8-4CC9-851C-AD4545442039</title>
          <defs>
            <rect
              id="path-1"
              x="0"
              y="0"
              width="1296"
              height="54"
              rx="4"
            ></rect>
            <filter
              x="-0.8%"
              y="-14.8%"
              width="101.5%"
              height="137.0%"
              filterUnits="objectBoundingBox"
              id="filter-2"
            >
              <feOffset
                dx="0"
                dy="2"
                in="SourceAlpha"
                result="shadowOffsetOuter1"
              ></feOffset>
              <feGaussianBlur
                stdDeviation="3"
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
              ></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0.686383929   0 0 0 0 0.686383929   0 0 0 0 0.686383929  0 0 0 0.2 0"
                type="matrix"
                in="shadowBlurOuter1"
              ></feColorMatrix>
            </filter>
          </defs>
          <g
            id="Designs"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Processor2" transform="translate(-677.000000, -204.000000)">
              <rect fill="#FFFFFF" x="0" y="0" width="1376" height="800"></rect>
              <rect
                id="Rectangle"
                fill="#F6F6F6"
                x="0"
                y="80"
                width="1376"
                height="720"
              ></rect>
              <g
                id="Group-7-Copy-8"
                transform="translate(40.000000, 184.000000)"
              >
                <g id="Rectangle-11-Copy">
                  <use
                    fill="black"
                    fillOpacity="1"
                    filter="url(#filter-2)"
                    href="#path-1"
                  ></use>
                  <use fill="#FFFFFF" fillRule="evenodd" href="#path-1"></use>
                </g>
                <g
                  id="Group-6"
                  transform="translate(481.000000, 20.000000)"
                  fill={this.props.fillColor || "#E52222"}
                  fillRule="nonzero"
                >
                  <g id="Group-4">
                    <path
                      d="M163.377778,4.97777778 L163.377778,4.97777778 C163.466667,4.97777778 163.466667,4.97777778 163.377778,4.97777778 C163.466667,4.62222222 163.555556,4.44444444 163.555556,4.17777778 L163.555556,4 C163.644444,3.55555556 163.644444,3.2 163.555556,3.11111111 C163.555556,3.11111111 163.555556,3.11111111 163.555556,3.02222222 L163.466667,2.93333333 L163.466667,2.93333333 L163.466667,2.93333333 C163.466667,2.93333333 163.466667,3.02222222 163.377778,3.02222222 C163.2,3.55555556 163.2,4.17777778 163.377778,4.97777778 L163.377778,4.97777778 Z M160.711111,11.1111111 C160.533333,11.2 160.355556,11.2888889 160.266667,11.3777778 C159.644444,11.9111111 159.2,12.5332985 159.111111,12.8 L159.111111,12.8 L159.111111,12.8 L159.111111,12.8 C159.644444,12.7111111 160.177778,12.1777778 160.711111,11.1111111 C160.8,11.1111111 160.8,11.1111111 160.711111,11.1111111 C160.8,11.1111111 160.711111,11.1111111 160.711111,11.1111111 Z M168.888889,9.77777778 C168.8,9.68888889 168.444444,9.42222222 167.2,9.42222222 C167.111111,9.42222222 167.111111,9.42222222 167.022222,9.42222222 L167.022222,9.42222222 C167.022222,9.42222222 167.022222,9.42222222 167.022222,9.51111111 C167.644444,9.77777778 168.266667,9.95555556 168.711111,9.95555556 C168.8,9.95555556 168.8,9.95555556 168.888889,9.95555556 L168.888889,9.95555556 L168.977778,9.95555556 C168.977778,9.95555556 168.977778,9.95555556 168.977778,9.86666667 L168.977778,9.86666667 C168.977778,9.86666667 168.888889,9.86666667 168.888889,9.77777778 Z M170.222222,0 L157.777778,0 C156.8,0 156,0.8 156,1.77777778 L156,14.2222222 C156,15.2 156.8,16 157.777778,16 L170.222222,16 C171.2,16 172,15.2 172,14.2222222 L172,1.77777778 C172,0.8 171.2,0 170.222222,0 Z M169.244444,10.4888889 C169.066632,10.5777778 168.8,10.6666667 168.444444,10.6666667 C167.733333,10.6666667 166.666667,10.4888889 165.777778,10.0444444 C164.266667,10.2222222 163.111111,10.3999651 162.222222,10.7555207 C162.133333,10.7555207 162.133333,10.7555207 162.044444,10.8444096 C160.977778,12.7111111 160.088889,13.6 159.377778,13.6 C159.2,13.6 159.111111,13.6 159.022222,13.5110763 L158.577778,13.2444444 L158.577778,13.1555556 C158.488889,12.9777429 158.488889,12.8888889 158.488889,12.7111111 C158.577778,12.2666667 159.111111,11.4666667 160.177778,10.8444096 C160.355556,10.7555207 160.622222,10.5777778 160.977778,10.3999651 C161.244444,9.9555207 161.511111,9.42218736 161.866667,8.8 C162.311111,7.91111111 162.577778,7.02222222 162.844444,6.22222222 L162.844444,6.22222222 C162.488889,5.15555556 162.311111,4.53333333 162.666667,3.28888889 C162.755556,2.93333333 163.022222,2.57777778 163.377778,2.57777778 L163.555556,2.57777778 C163.733333,2.57777778 163.911111,2.66666667 164.088889,2.75555556 C164.711146,3.37777778 164.444444,4.8 164.088889,5.95555556 C164.088889,6.04444444 164.088889,6.04444444 164.088889,6.04444444 C164.444444,7.02222222 164.977778,7.82222222 165.511111,8.35555556 C165.777778,8.53333333 165.955556,8.71111111 166.311111,8.88888889 C166.755556,8.88888889 167.111111,8.8 167.466667,8.8 C168.533333,8.8 169.244444,8.97777778 169.511076,9.42222222 C169.6,9.60003486 169.6,9.77777778 169.6,9.95555556 C169.511111,10.0444444 169.422222,10.3111111 169.244444,10.4888889 Z M163.466667,7.02222222 C163.288889,7.64444444 162.933333,8.35555556 162.577778,9.15555556 C162.4,9.51107625 162.222222,9.77777778 162.044444,10.1333333 L162.133333,10.1333333 L162.222222,10.1333333 L162.222222,10.1333333 C163.377778,9.68888889 164.444444,9.42222222 165.155556,9.33333333 C164.977743,9.24444444 164.888889,9.15555556 164.8,9.06666667 C164.355556,8.53333333 163.822222,7.82222222 163.466667,7.02222222 Z"
                      id="PDF"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

export default PdfICon;
